import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { appBranchesPath } from '@/utils/publicApiRouteService';
import { publicApi } from '@/utils/api';
import { SimpleErrorResponse } from '@/models/Error';
import { queryClient } from '@/utils/query';

type UseAppBranchesProps = {
  appSlug?: string;
  limit?: number;
};

type UseBranchesForFilterResponse = AxiosResponse<{ data?: { name: string }[] }>;

const useAppBranchesForFilter = ({ appSlug, limit = 10 }: UseAppBranchesProps) => {
  const queryKey = useCallback((keyword: string = '') => [appSlug, limit, keyword], [appSlug, limit]);
  const queryFn = useCallback(
    (keyword: string = '') =>
      () =>
        publicApi.get<{ data?: { name: string }[] }>(appBranchesPath(appSlug || '', keyword, limit)),
    [appSlug, limit],
  );

  const { data } = useQuery<unknown, SimpleErrorResponse, UseBranchesForFilterResponse>({
    queryKey: queryKey(),
    queryFn: queryFn(),
    retry: false,
  });

  const fetchQuery = useCallback(
    (keyword: string) => {
      return queryClient.fetchQuery({
        queryKey: queryKey(keyword),
        queryFn: queryFn(keyword),
        retry: false,
      });
    },
    [queryFn, queryKey],
  );

  return {
    data: data?.data.data,
    fetchQuery,
  };
};

export default useAppBranchesForFilter;
